import { useFollowings } from "../../../js/api/follow-member/follow-member";
import { FollowMemberButton } from "../follow-member/follow-member-button";
import { useToggleFollowMember } from "../follow-member/use-toggle-follow-member";
import { useActivityFeed } from "./activity-feed";

export const ActivityFollowButton = ({ activityData }) => {
  const { data, isLoading, isError } = useFollowings();
  const isUserFollowing = data?.find(
    (following) => following.id === activityData.targetMember.umbracoUserId
  );
  const { followTitle, followingTitle } = useActivityFeed();
  const { isSpinnerVisible, toggleClickHandler } = useToggleFollowMember({
    memberId: activityData.targetMember.umbracoUserId,
    isFollowed: activityData.targetMember.isFollowee,
    followingMessage: null,
    queriesToInvalidate: ["followings"],
    useFollowingsData: true,
    isFollowingsUserFollowing: isUserFollowing,
  });

  return (
    <>
      {!activityData?.targetMember?.isCurrentUser && !isLoading && !isError && (
        <FollowMemberButton
          isFollowing={isUserFollowing}
          isLoading={isSpinnerVisible}
          disabled={isSpinnerVisible}
          toggleClickHandler={toggleClickHandler}
          isSmall={true}
          followTitle={followTitle}
          followingTitle={followingTitle}
          hasIcon={true}
        />
      )}
    </>
  );
};
